const getBirthdateByIdentifier = (identifier: string) => {
  if (!identifier) return null;
  return `19${identifier
    .slice(4, 10)
    .match(/.{1,2}/g)
    .join('-')}`;
};

export default getBirthdateByIdentifier;
